import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { VariableTypeEnum } from '../ontology/variable-type.enum';
import { VariableDetails } from '../ontology/model/variable-details';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'jhi-variable-select-modal',
    templateUrl: './variable-select-modal.component.html'
})
export class VariableSelectModalComponent implements OnInit, OnDestroy {

    title: string;
    isLoading: boolean;
    germplasmUUID: string;

    VARIABLE_TYPE_IDS;
    variable: VariableDetails;

    constructor(public activeModal: NgbActiveModal,
                public translateService: TranslateService,
                private route: ActivatedRoute) {

        const queryParamMap = this.route.snapshot.queryParamMap;
        this.germplasmUUID = queryParamMap.get('germplasmUUID');
        this.VARIABLE_TYPE_IDS = [VariableTypeEnum.ENTRY_DETAIL];

    }

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.activeModal.close(this.variable);
    }

    selectVariable(variable: VariableDetails) {
        this.variable = variable;
    }

    isFormValid(f) {
        return f.form.valid && !this.isLoading && this.variable;
    }

}
